/* eslint-disable max-len */

export default function RectangleIcon() {
    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path d="M38,18v12c0,1.654-1.346,3-3,3H13c-1.654,0-3-1.346-3-3v-12c0-1.654,1.346-3,3-3h22c1.654,0,3,1.346,3,3Z" fill="#D9D9D9" />
        </svg>
    );
}
